export const TAB = Object.freeze({
	ROUTES: "routes",
	LOGOUT: "logout",
	HANDOVER: "handover",
	REQUESTS: "requests",
});

export const HANDOVER_MODE = Object.freeze({
	ROUTE: "route",
	PATIENT: "patient",
	UNTEMPERED: "untempered",
});
